module.exports = __webpack_public_path__ + "static/img/bcg4.dcb0e113.png";